import { Injectable } from '@angular/core';
import {HttpClient, HttpErrorResponse, HttpHeaders, HttpParams} from '@angular/common/http';
import {Observable, of, throwError} from 'rxjs';
import {LoanApplicationConstant} from './loan-application-constant';
import {CommonUtilService} from "@services/common-util.service";
import {catchError} from "rxjs/operators";
import {environment} from "../../../../environments/environment";
const API_URL = environment.POS_BFF_URL;
import { map } from "rxjs/operators";
import {AppUser} from "../schema/account/app-user";
import {Client} from "@data/schema/account/client";
import {ExternalService} from "@data/schema/account/external-service";
import {UserRole} from "@data/schema/account/user-role";
import {UserPermission} from "@data/schema/account/user-permission";
import {Branch} from "@data/schema/account/branch";
import { LoanDocumentSet} from "@data/schema/account/document-set";
import {LoanDocumentType} from "@data/schema/account/document-type";
@Injectable({
  providedIn: 'root'
})
export class AccountService {
  constructor(private http: HttpClient, private loanApplicationConstants: LoanApplicationConstant
    , private commonUtilService: CommonUtilService) {
  }
  headerDict = {
    'Content-Type': 'application/json',
    'Accept': 'application/json',
    'Access-Control-Allow-Origin': '*',
  };
  requestOptions = {
    headers: new HttpHeaders(this.headerDict)
  };


  errorHandler(error: HttpErrorResponse) {
    if (error.error instanceof ErrorEvent) {
      // A client-side or network error occurred. Handle it accordingly.
      console.error("An error occurred:", error.error.message);
      console.log(error);
    } else {
      // The backend returned an unsuccessful response code.
      // The response body may contain clues as to what went wrong,
      console.log(error);
      console.error(
        `Backend returned code ${error.status}, ` + `body was: ${error.error}`
      );
    }
    // return an observable with a user-facing error message
    return throwError("Something bad happened; please try again later.");
  }

  public getAppUser(userNameOrEmail: string): Observable<AppUser> {
    return this.http
      .get(
        API_URL + "/api/v1/oauth/get-user?emailOrUserName="+userNameOrEmail,
         )
      .pipe(
        map(response => {
          return response as AppUser;
        })
      )
      .pipe(catchError(this.errorHandler))

  }
  public getUserByUserId(userId: string): Observable<AppUser> {
    return this.http
      .get(
        API_URL + "/api/v1/oauth/get-user-by-userid?userId="+userId,
      )
      .pipe(
        map(response => {
          return response as AppUser;
        })
      )
      .pipe(catchError(this.errorHandler))

  }
  public getActiveClients(): Observable<Client[]> {
    const clients = this.http
      .get(environment.POS_BFF_URL
        +'/api/v1/oauth/get-active-clients?activeClientFlag=true')
      .pipe(
        map(response => {
          return response as Client[];
        })
      );

    return clients;
  }
  public createNewClient(client: Client): Observable<Client> {
    return  this.http
      .post(environment.POS_BFF_URL+"/api/v1/oauth/create-client", client )
      .pipe(
        map(response => {
          return response as Client;
        })
      );
  }
  public saveClient(client: Client): Observable<Client> {
    return  this.http
      .post(environment.POS_BFF_URL+"/api/v1/oauth/save-client", client )
      .pipe(
        map(response => {
          return response as Client;
        })
      );
  }
  public deleteClient(client: Client): Observable<Client> {
    return  this.http
      .post(environment.POS_BFF_URL+"/api/v1/oauth/delete-client", client )
      .pipe(
        map(response => {
          return response as Client;
        })
      );
  }
  public getClientById(clientId: string): Observable<Client> {
    return this.http
      .get(
        environment.POS_BFF_URL + "/api/v1/oauth/get-client-by-id?clientId="+clientId)
      .pipe(
        map(response => {
          return response as Client;
        })
      )

  }

  public createNewExternalService(client: ExternalService): Observable<ExternalService> {
    return  this.http
      .post(environment.POS_BFF_URL+"/api/v1/oauth/create-external-service", client )
      .pipe(
        map(response => {
          return response as ExternalService;
        })
      );
  }
  public saveExternalService(externalService: ExternalService): Observable<ExternalService> {
    return  this.http
      .post(environment.POS_BFF_URL+"/api/v1/oauth/save-external-service", externalService )
      .pipe(
        map(response => {
          return response as ExternalService;
        })
      );
  }
  public deleteExternalService(externalService: ExternalService): Observable<ExternalService> {
    return  this.http
      .post(environment.POS_BFF_URL+"/api/v1/oauth/delete-external-service", externalService )
      .pipe(
        map(response => {
          return response as ExternalService;
        })
      );
  }
  public getExternalServiceById(externalServiceId: string): Observable<ExternalService> {
    return this.http
      .get(
        environment.POS_BFF_URL + "/api/v1/oauth/get-external-service-by-id?externalServiceId="+externalServiceId)
      .pipe(
        map(response => {
          return response as ExternalService;
        })
      )

  }
  public getExternalServiceByClientId(clientId : string): Observable<ExternalService[]> {
    const externalServices = this.http
      .get(environment.POS_BFF_URL
        +'/api/v1/oauth/get-external-service-by-clientid?clientId='+clientId)
      .pipe(
        map(response => {
          return response as ExternalService[];
        })
      );

    return externalServices;
  }
  public getAppUsers(clientId : string): Observable<AppUser[]> {
    const appUsers = this.http
      .get(environment.POS_BFF_URL
        +'/api/v1/oauth/get-users-by-clientid?clientId='+clientId)
      .pipe(
        map(response => {
          return response as AppUser[];
        })
      );

    return appUsers;
  }

  public addUser(appUser: AppUser): Observable<AppUser> {
    return  this.http
      .post(environment.POS_BFF_URL+"/api/v1/oauth/add-user", appUser )
      .pipe(
        map(response => {
          return response as AppUser;
        })
      );
  }
  public editUser(appUser: AppUser): Observable<AppUser> {
    return  this.http
      .post(environment.POS_BFF_URL+"/api/v1/oauth/save-user", appUser )
      .pipe(
        map(response => {
          return response as AppUser;
        })
      );
  }
  public deleteUser(appUser: AppUser): Observable<AppUser> {
    return  this.http
      .post(environment.POS_BFF_URL+"/api/v1/oauth/delete-user", appUser )
      .pipe(
        map(response => {
          return response as AppUser;
        })
      );
  }
  public resendCredentials(appUser: AppUser): Observable<AppUser> {
    return  this.http
      .post(environment.POS_BFF_URL+"/api/v1/oauth/resend-credentials", appUser )
      .pipe(
        map(response => {
          return response as AppUser;
        })
      );
  }
  public disableUser(appUser: AppUser): Observable<AppUser> {
    return  this.http
      .post(environment.POS_BFF_URL+"/api/v1/oauth/disable-user", appUser )
      .pipe(
        map(response => {
          return response as AppUser;
        })
      );
  }
  public enableUser(appUser: AppUser): Observable<AppUser> {
    return  this.http
      .post(environment.POS_BFF_URL+"/api/v1/oauth/enable-user", appUser )
      .pipe(
        map(response => {
          return response as AppUser;
        })
      );
  }
  public getAppUserByUserId(userId: string): Observable<AppUser> {
    return this.http
      .get(
        environment.POS_BFF_URL + "/api/v1/oauth/get-user-by-userid?userId="+userId)
      .pipe(
        map(response => {
          return response as AppUser;
        })
      )

  }
  public getUserRoleById(roleId: string): Observable<UserRole> {
    return this.http
      .get(
        environment.POS_BFF_URL + "/api/v1/oauth/get-user-role-by-id?roleId="+roleId)
      .pipe(
        map(response => {
          return response as UserRole;
        })
      )

  }
  public getUserRoles(clientId : string): Observable<UserRole[]> {
    const userRoles = this.http
      .get(environment.POS_BFF_URL
        +'/api/v1/oauth/get-user-roles-by-clientid?clientId='+clientId)
      .pipe(
        map(response => {
          return response as UserRole[];
        })
      );

    return userRoles;
  }
  public addRole(userRole: UserRole): Observable<UserRole> {
    return  this.http
      .post(environment.POS_BFF_URL+"/api/v1/oauth/add-user-role", userRole )
      .pipe(
        map(response => {
          return response as UserRole;
        })
      );
  }
  public deleteUserRole(userRole: UserRole): Observable<UserRole> {
    return  this.http
      .post(environment.POS_BFF_URL+"/api/v1/oauth/delete-user-role", userRole )
      .pipe(
        map(response => {
          return response as UserRole;
        })
      );
  }
  public editUserRole(userRole: UserRole): Observable<UserRole> {
    return  this.http
      .post(environment.POS_BFF_URL+"/api/v1/oauth/save-user-role", userRole )
      .pipe(
        map(response => {
          return response as UserRole;
        })
      );
  }

  public getUserPermissions(clientId : string): Observable<UserPermission[]> {
    const userPermissions = this.http
      .get(environment.POS_BFF_URL
        +'/api/v1/oauth/get-permission-by-clientid?clientId='+clientId)
      .pipe(
        map(response => {
          return response as UserPermission[];
        })
      );

    return userPermissions;
  }
  public addUserPermissions(userPermission: UserPermission): Observable<UserPermission> {
    return  this.http
      .post(environment.POS_BFF_URL+"/api/v1/oauth/add-user-permission", userPermission )
      .pipe(
        map(response => {
          return response as UserPermission;
        })
      );
  }
  public deleteUserPermission(userPermission: UserPermission): Observable<UserPermission> {
    return  this.http
      .post(environment.POS_BFF_URL+"/api/v1/oauth/delete-user-permission", userPermission )
      .pipe(
        map(response => {
          return response as UserPermission;
        })
      );
  }
  public editUserPermission(userPermission: UserPermission): Observable<UserPermission> {
    return  this.http
      .post(environment.POS_BFF_URL+"/api/v1/oauth/save-user-permission", userPermission )
      .pipe(
        map(response => {
          return response as UserPermission;
        })
      );
  }
  public getUserPermissionById(permissionId: string): Observable<UserPermission> {
    return this.http
      .get(
        environment.POS_BFF_URL + "/api/v1/oauth/get-user-permission-by-id?permissionId="+permissionId)
      .pipe(
        map(response => {
          return response as UserPermission;
        })
      )

  }
  isBorrower(appUser : AppUser){
    if(appUser.roleList){
      for(let i = 0; i < appUser.roleList.length; i++){
        if(appUser.roleList[i] && appUser.roleList[i].permissionList) {
          for (let j = 0; j < appUser.roleList[i].permissionList.length; j++) {
            if (appUser.roleList[i].permissionList) {
              if (appUser.roleList[i].permissionList[j].name.includes('Borrower')) {
                  return true;
              }
            }


          }
        }
      }

    }
    return false;
  }
  isLoanOfficer(appUser : AppUser){
    const userPermissionList : UserPermission[] =[];
    if(appUser.roleList){
      for(let i = 0; i< appUser.roleList.length; i++){
        if(appUser.roleList[i] && appUser.roleList[i].permissionList) {
          for (let j = 0; j < appUser.roleList[i].permissionList.length; j++) {
            if(appUser.roleList[i].permissionList[j]){
              if(appUser.roleList[i].permissionList[j].name.includes('Officer'))
              {
                return true;

              }
            }

          }
        }
      }

    }
    return false;
  }
  public getBranchByClientId(clientId : string): Observable<Branch[]> {
    const branches = this.http
      .get(environment.POS_BFF_URL
        +'/api/v1/oauth/get-branch-by-clientid?clientId='+clientId)
      .pipe(
        map(response => {
          return response as Branch[];
        })
      );

    return branches;
  }
  public createBranch(branch: Branch): Observable<Branch> {
    return  this.http
      .post(environment.POS_BFF_URL+"/api/v1/oauth/create-branch", branch )
      .pipe(
        map(response => {
          return response as Branch;
        })
      );
  }
  public editBranch(branch: Branch): Observable<Branch> {
    return  this.http
      .post(environment.POS_BFF_URL+"/api/v1/oauth/save-branch", branch )
      .pipe(
        map(response => {
          return response as Branch;
        })
      );
  }
  public getBranchById(branchId: string): Observable<Branch> {
    return this.http
      .get(
        environment.POS_BFF_URL + "/api/v1/oauth/get-branch-by-id?branchId="+branchId)
      .pipe(
        map(response => {
          return response as Branch;
        })
      )

  }
  public deleteBranch(branch: Branch): Observable<Branch> {
    return  this.http
      .post(environment.POS_BFF_URL+"/api/v1/oauth/delete-branch", branch )
      .pipe(
        map(response => {
          return response as Branch;
        })
      );
  }


  public getUsersByBranchIdAndClientId(branchId: string, clientId : string): Observable<AppUser[]> {
    const users = this.http
      .get(environment.POS_BFF_URL
        + '/api/v1/oauth/get-users-by-branchid-clientid?branchId='+branchId+'&clientId=' + clientId)
      .pipe(
        map(response => {
          return response as AppUser[];
        })
      );

    return users;
  }
  public getUsersByClientIdAndRoleId(clientId : string, roleId : string): Observable<AppUser[]> {
    const users = this.http
      .get(environment.POS_BFF_URL
        + '/api/v1/oauth/get-users-by-clientid-roleid?&clientId='+clientId+'&roleId='+roleId)
      .pipe(
        map(response => {
          return response as AppUser[];
        })
      );

    return users;
  }

  public isAllowed(nounType : number,verbType : number , appUser : AppUser) {
    let isAllowed = false;
    if (appUser.roleList ) {
    for (let i = 0; i < appUser.roleList.length; i++) {
      if(appUser.roleList[i].permissionList) {
        for (let j = 0; j < appUser.roleList[i].permissionList.length; j++) {
          const permission = appUser.roleList[i].permissionList[j];
          if (permission.verbType === verbType
            && permission.nounType === nounType) {
            isAllowed = true;
            break;
          }
        }
      }
    }
  }
    return isAllowed;
  }
  public getDocumentTypes(clientId : string): Observable<LoanDocumentType[]> {
    const documentType = this.http
      .get(environment.POS_BFF_URL
        +'/api/v1/oauth/get-loan-document-types-by-clientid?clientId='+clientId)
      .pipe(
        map(response => {
          return response as LoanDocumentType[];
        })
      );

    return documentType;
  }
  public getDocumentTypeById(clientId : string,documentTypeId : string): Observable<LoanDocumentType> {
    const documentType = this.http
      .get(environment.POS_BFF_URL
        +'/api/v1/oauth/get-loan-document-type-by-client-id-and-document-type-id?clientId='+clientId+'&documentTypeId='+documentTypeId)
      .pipe(
        map(response => {
          return response as LoanDocumentType;
        })
      );

    return documentType;
  }
  public getDocumentSetById(clientId : string,documentSetId : string): Observable<LoanDocumentSet> {
    const documentType = this.http
      .get(environment.POS_BFF_URL
        +'/api/v1/oauth/document-set-by-client-id-and-document-set-id?clientId='+clientId+'&documentSetId='+documentSetId)
      .pipe(
        map(response => {
          return response as LoanDocumentSet;
        })
      );

    return documentType;
  }
  public getDocumentSets(clientId : string): Observable<LoanDocumentSet[]> {
    const documentSet = this.http
      .get(environment.POS_BFF_URL
        +'/api/v1/oauth/document-set-by-client-id?clientId='+clientId)
      .pipe(
        map(response => {
          return response as LoanDocumentSet[];
        })
      );

    return documentSet;
  }
  public deleteDocumentType(loanDocumentType: LoanDocumentType): Observable<LoanDocumentType> {
    return  this.http
      .post(environment.POS_BFF_URL+"/api/v1/oauth/hard-delete-document-type", loanDocumentType )
      .pipe(
        map(response => {
          return response as LoanDocumentType;
        })
      );
  }
  public deleteDocumentSet(loanDocumentSet: LoanDocumentSet): Observable<LoanDocumentSet> {
    return  this.http
      .post(environment.POS_BFF_URL+"/api/v1/oauth/hard-delete-document-set", loanDocumentSet )
      .pipe(
        map(response => {
          return response as LoanDocumentSet;
        })
      );
  }
  public editLoanDocumentType(loanDocumentType: LoanDocumentType): Observable<LoanDocumentType> {
    return  this.http
      .post(environment.POS_BFF_URL+"/api/v1/oauth/update-document-type", loanDocumentType )
      .pipe(
        map(response => {
          return response as LoanDocumentType;
        })
      );
  }
  public editLoanDocumentSet(loanDocumentSet: LoanDocumentSet): Observable<LoanDocumentSet> {
    return  this.http
      .post(environment.POS_BFF_URL+"/api/v1/oauth/update-document-set", loanDocumentSet )
      .pipe(
        map(response => {
          return response as LoanDocumentSet;
        })
      );
  }
  public CreateLoanDocumentSet(loanDocumentSet: LoanDocumentSet): Observable<LoanDocumentSet> {
    return  this.http
      .post(environment.POS_BFF_URL+"/api/v1/oauth/create-document-set", loanDocumentSet )
      .pipe(
        map(response => {
          return response as LoanDocumentSet;
        })
      );
  }

  public CreateLoanDocumentType(loanDocumentType: LoanDocumentType): Observable<LoanDocumentType> {
    return  this.http
      .post(environment.POS_BFF_URL+"/api/v1/oauth/create-document-type", loanDocumentType )
      .pipe(
        map(response => {
          return response as LoanDocumentType;
        })
      );
  }


}

